import { CancelToken } from 'axios';
import { http } from '../helpers/axiosHelper';

export default class ConsultantService {
   async getConsultants(cancelToken?: CancelToken) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/consultant', { cancelToken: cancelToken }).then((response) => {
         return response.data;
      });
   }

   async getConsultant(consultantId: string) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/consultant/' + consultantId).then((response) => {
         return response.data;
      });
   }

   async createConsultant(body: any) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/consultant', body).then((response) => {
         return response.data;
      });
   }

   async editConsultant(id: Number, body: any) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/consultant/' + id, body).then((response) => {
         return response.data;
      });
   }

   async patchConsultant(id: Number, body: any) {
      if (Array.isArray(body)) {
      } else {
         body = [body];
      }
      return await http.patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/consultant/' + id, body).then((response) => response.data);
   }

   async deleteConsultant(consultantId: string) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/consultant/' + consultantId).then((response) => {
         return response.data;
      });
   }

   async postConsultantJourney(consultantId: Number, journeyId: Number) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/consultant-journey', { consultant_id: consultantId, journey_id: journeyId })
         .then((response) => {
            return response.data;
         });
   }

   async deleteConsultantJourney(consultantJourneyId: Number) {
      return await http
         .delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/consultant-journey/' + consultantJourneyId)
         .then((response) => {
            return response.data;
         });
   }
}
